import * as React from 'react';

export const ButtonsGroup = (props: any) => {
  return (
    <div className="buttons-group">
      {props.children}
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/components/Layout/components/ButtonsGroup/ButtonsGroup.tsx